<template>
  <section>
      <div class="d-flex justify-content-start align-items=end mb-2">
        <b-form-group label="RMA No." class="mr-2">
          <b-form-input v-model="filterObj.rmaNumber" @input="onFilter"></b-form-input>
        </b-form-group>
        <b-form-group label="Invoice No." class="mr-2">
          <b-form-input v-model="filterObj.invoiceNumber" @input="onFilter"></b-form-input>
        </b-form-group>
        <b-form-group label="Part Number" class="mr-2">
          <b-form-input v-model="filterObj.partNumber" @input="onFilter"></b-form-input>
        </b-form-group>
        <b-form-group label="Customer Part Number" class="mr-2">
          <b-form-input v-model="filterObj.customerPn" @input="onFilter"></b-form-input>
        </b-form-group>
        <div class="clear-filter-button-container mt-3">
          <b-button size="sm" @click="onClearFilter">Clear filters</b-button>
        </div>
      </div>
      <grid-component
        isResizable
        isReorderable
        :canEdit="checkClaim(CAN_EDIT_RMAS)"
        :canDelete="checkClaim(CAN_DELETE_RMAS)"
        :gridId="gridId"
        :pageable="pageable"
        :itemData="itemData"
        :skip="pageInfo.pageSize * (pageInfo.pageNumber - 1)"
        :take="pageInfo.pageSize"
        :pageSizes="pageInfo.pageSize"
        :totalItems="pageInfo.totalItems"
        :sortBy="pageInfo.sortBy"
        :sortOrder="pageInfo.sortOrder"
        :sortMethod="sortGrid"
        :fields="fields"
        :onEdit="pushToDetails"
        :onDelete="onDelete"
        :handleRowClick="onRowClick"
        :navigationField="'RMAId'"
        :isTblLoader="tblLoader"
        :styleCustom="'height: 210px'"
        @getData="onGetData"
      />
  </section>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from 'vuex';
import debounce from 'lodash/debounce';
import { SORT_ORDER, GRID_PAGE_SIZES, PAGE_SIZE, GRID_ID, SEARCH_DEBOUNCE_TIME } from '@/shared/constants';
import GridSettings from '@/shared/components/GridSettings';
import GridComponent from '@/shared/components/GridComponent';
import gridFields from '@/pages/Customerrmas/components/CustomerrmasLines/fields';

export default {
  components: {
    GridSettings,
    GridComponent
  },
  props: {
    companyId: {
      type: [Number, String],
      default: 0,
    },
    partId: {
      type: [String, Number],
      default: 0,
    }
  },
  data() {
    return {
      filtersVisible: false,
      fields: gridFields,
      gridId: GRID_ID.CUSTOMER_RMA_LINES_TAB,
      pageable: {
        pageSizes: GRID_PAGE_SIZES,
      },
      selectedRowItemId: 0,
      filterObj: {}
    };
  },
  computed: {
    ...mapGetters('rmaLinesComponent', ['rmaLines','pageInfo', 'filters', 'tblLoader']),
    ...mapGetters('account', ['gridSettingsById']),
    itemData() {
      return this.rmaLines;
    },
  },
  methods: {
    ...mapMutations('rmaLinesComponent', ['setItem']),
    ...mapActions('rmaLinesComponent', ['getAll', 'sortGrid']),
    ...mapActions('customerrmas', ['onDeleteRMALine']),
    onRowClick(row) {
      this.selectedRowItemId = row.dataItem.id;
    },
    onFilter: debounce(function() {
      this.setItem({ resource: 'pageInfo', payload: {...this.pageInfo, pageNumber: 1}});
      this.setItem({ resource: 'filters', payload: {...this.filters, ...this.filterObj} });
    }, SEARCH_DEBOUNCE_TIME),
    onClearFilter() {
      this.clearObject(this.filterObj);
      this.onFilter();
    },
    pushToDetails(row) {
      this.$router.push({
        name: 'customerrmas.edit',
        params: { id: row.rmaId },
      });
    },
    async onDelete(item) {
      const deleteConfirmed = await this.openConfirmBox({message: `Are you sure you want to delete rma line?`});
      if (deleteConfirmed) {
        const result = await this.onDeleteRMALine({
          rmaId: item.rmaId,
          rmaLineId: item.id
        }).then(() => this.getAll({}));
        
      }
    },
    async onGetData(params) {
      await this.getAll(params);
    },
  },
  watch: {
    companyId() {
      this.setItem({ resource: 'filters', payload: {...this.filters, companyId: this.companyId} });
    },
    partId() {
      this.setItem({ resource: 'filters', payload: {...this.filters, partId: this.partId} });
    },
    filters() {
      this.getAll({});
    }
  },
  mounted() {
    this.setItem({resource: 'filters', payload: { companyId: this.companyId, partId: this.partId }});
    // this.getrmaLines({});  
  }
};
</script>

<style lang="scss">
@import '@/assets/scss/_colors.scss';

.highlight {
  background: $rowSelection !important;
}

.b-pagination {
  justify-content: center;
}

.tools > * {
  margin: 0 0 0 3px;
}

#KendoGrid .k-virtual-scrollable-wrap table {
  min-width: 800px;
}
</style>
